import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../tables/Table';

import useCustomTable from '../../tables/useCustomTable';
import * as Format from "../../Format";
import Pagination from "../../tables/Pagination";
import Block from "../../Block";
import versionCompare from "../../../services/versionCompare";

const ConsentByLayoutTable = ({data = [], isSuccess, isFetching: isLoading, refetch}) => {

  const { t } = useTranslation();

  const {
    tableProps,
    paginationProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {consentRequestLayoutVersion: 'asc'}
  });

  const columns = [{
    Header: 'Version',
    accessor: 'consentRequestLayoutVersion',
    sortType: (rowA, rowB, id, desc) => (versionCompare(rowB.original.consentRequestLayoutVersion,rowA.original.consentRequestLayoutVersion))
  },{
    Header: t("cmp.analytics.metrics.devicesWithCmpPresented"),
    accessor: 'devicesWithCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.consentedDevices"),
    accessor: 'consentedDevices',
  },{
    Header: t("cmp.analytics.metrics.consentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.consentRate*100}/>,
    accessor: 'consentRate',
  },{
    Header: t("cmp.analytics.metrics.averageDisplayRank"),
    Cell: ({row}) => <Format.Number value={row.original.avgDisplayRank} digits={2}/>,
    accessor: 'avgDisplayRank'
  }];

  const dataToTableRow = (el) => ({
    ...el,
    consentRate: (el.devicesWithCmpPresented || 0) > 0 ? el.consentedDevices/el.devicesWithCmpPresented : 0
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  return (
    <>
      <Block isLoading={isLoading} isSuccess={isSuccess}>
        <Table noPadding data={tableData} columns={columns} {...tableProps} />
      </Block>
      {isSuccess && !isLoading && <Pagination {...paginationProps}/>}
    </>)
}

export default ConsentByLayoutTable
